import React from "react";

export default function ServiceSection(props) {
  const ServiceColumns = [
    {
      id: 1,
      src: "next-js.png",
      details: "Next.js",
    },
    {
      id: 2,
      src: "React.webp",
      details: "React.js",
    },
    {
      id: 3,
      src: "typescrupt.png",
      details: "TypeScript",
    },
    {
      id: 4,
      src: "java.png",
      details: "JavaScript",
    },
    {
      id: 5,
      src: "tailwind.png",
      details: "Tailwind CSS",
    },
    {
      id: 6,
      src: "html.png",
      details: "HTML5",
    },
    {
      id: 7,
      src: "css.png",
      details: "CSS3",
    },
    {
      id: 8,
      src: "rest-api.png",
      details: "REST APIs",
    },
    {
      id: 9,
      src: "firebase.png",
      details: "Firebase",
    },
    {
      id: 10,
      src: "git.png",
      details: "Git & GitHub",
    },
    {
      id: 11,
      src: "WordPress.png",
      details: "WordPress",
    },
    {
      id: 12,
      src: "shopify.png",
      details: "Shopify",
    },
  ];

  return (
    <section className="skillsSection">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="aboutHeadings text-center">
              <h2>{props.skillsHeading}</h2>

              <h4 className="brandText">
                {props.skillsSubHeading}
              </h4>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          {ServiceColumns.map((skillsColumn, index) => (
            <div
              key={skillsColumn.id}
              className="col-md-3 col-sm-6 mb-4"
              data-aos="fade-up"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="800"
              data-aos-delay={index * 100}
            >
              <div
                className={`skillsColumns bg-${
                  props.mode === "light" ? "light" : "light2"
                } text-${props.mode === "light" ? "dark" : "light"}`}
              >
                <div className="skillsColumnImage">
                  <img
                    src={skillsColumn.src}
                    alt={`${skillsColumn.details} logo`}
                    className="img-fluid"
                  />
                </div>

                <p>{skillsColumn.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}